/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantItemDto } from './tenantItemDto';


export interface BuildingEmergencyContactDto { 
    id: string;
    contractor: TenantItemDto;
    type: BuildingEmergencyContactDto.TypeEnum;
    phone: string;
    email: string;
}
export namespace BuildingEmergencyContactDto {
    export type TypeEnum = 'WATER_DAMAGE' | 'HEATING_FAILURE' | 'STORM_DAMAGE';
    export const TypeEnum = {
        WaterDamage: 'WATER_DAMAGE' as TypeEnum,
        HeatingFailure: 'HEATING_FAILURE' as TypeEnum,
        StormDamage: 'STORM_DAMAGE' as TypeEnum
    };
}


